import clsx from 'clsx';
import type { IconProps } from '../components/types.js';
import { fgTone } from '../utils/style/tone.js';
const displayName = 'IconAppWindowNext';
/** Renders an SVG icon. */
const SvgAppWindowNext = ({
  size,
  'aria-hidden': ariaHidden,
  tone,
  UNSAFE_className,
  UNSAFE_style,
  ...rest
}: IconProps) => {
  const props = {
    ...rest,
    'aria-hidden': ariaHidden ?? (rest['aria-label'] == null && rest['aria-labelledby'] == null),
    className: clsx('cim-icon', tone && fgTone(tone), UNSAFE_className),
    style: UNSAFE_style,
    width: size != null ? size + 'px' : '1em',
    height: size != null ? size + 'px' : '1em',
  };
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" data-icon="true" fill="currentColor" {...props}>
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M4 7a3 3 0 0 1 3-3h18a3 3 0 0 1 3 3v7a1 1 0 1 1-2 0V7a1 1 0 0 0-1-1H7a1 1 0 0 0-1 1v18a1 1 0 0 0 1 1h7a1 1 0 1 1 0 2H7a3 3 0 0 1-3-3z"
      />
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M24.293 18.293a1 1 0 0 1 1.414 0l4 4a1 1 0 0 1 0 1.414l-4 4a1 1 0 0 1-1.414-1.414L26.586 24H22.5a2.5 2.5 0 0 0-2.5 2.5V28a1 1 0 1 1-2 0v-1.5a4.5 4.5 0 0 1 4.5-4.5h4.086l-2.293-2.293a1 1 0 0 1 0-1.414M4 11a1 1 0 0 1 1-1h22a1 1 0 1 1 0 2H5a1 1 0 0 1-1-1"
      />
      <path fill="currentColor" d="M9 8a1 1 0 1 1-2 0 1 1 0 0 1 2 0m3 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0" />
    </svg>
  );
};
SvgAppWindowNext.displayName = displayName;
export default SvgAppWindowNext;
